/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { CalendarDto, CalendarRequestDto } from './calendar.dto';
import { CalendarMapper, CalendarRequestMapper } from './calendar.mapper';

@Injectable()
export class SupplierCalendarRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  getAll(request: CalendarRequestDto): Observable<CalendarDto[]> {
    return this.httpPut(
      `/calendar`,
      request,
      CalendarRequestMapper,
      arrayOf(CalendarMapper),
    );
  }
}
